import { Component, computed, input } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

import { PercentageValuePipe } from "../../../../core/pipes";
import { AdaaHelper } from "../../../../core/utils";
import { Constants } from "../../../constants/constants";
import { Language } from "../../../constants/enums";
import { PictureComponent, ProgressIndicatorComponent } from "../../general";

@Component({
  selector: "adaa-intp-dashboard-card",
  imports: [TranslatePipe, PercentageValuePipe, ProgressIndicatorComponent, PictureComponent],
  templateUrl: "./intp-dashboard-card.html",
  styleUrl: "./intp-dashboard-card.scss",
})
export class IntpDashboardCardComponent {
  title = input.required<string>();
  type = input.required<"text" | "progress" | "project">();

  content = input<string>("");
  icon = input<string | number | undefined>(undefined);
  height = input<string>("2rem");

  progress = input<number>(0);
  progressColor = input<number>(0);

  visionScore = input<number>(0);
  visionScoreColor = input<number>(0);

  colorString = computed(
    () => Constants.COLOR_CODES[this.progressColor() ?? Constants.CONSTANT_COLORS.EVALUATION_GRAY]
  );

  AdaaHelper = AdaaHelper;
  Language = Language;
}
